var _linearGradient, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrongIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "placeholder wrong",
    viewBox: "0 0 362 175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.5,
    x2: 0.5,
    y1: 0.07,
    y2: 0.919,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4e9f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f8f8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h362v175H0z",
    style: {
      fill: "red"
    },
    transform: "translate(502 267)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    },
    transform: "translate(-502 -267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152 0h58a152 152 0 0 1 152 152H0A152 152 0 0 1 152 0z",
    "data-name": "bg card",
    style: {
      fill: "url(#b)"
    },
    transform: "translate(502 290)"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 2,
    "data-name": "Rectangle 390",
    rx: 1,
    transform: "translate(649 440)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#c)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16511.078 22188.9v.006h26.91a8.762 8.762 0 0 0 0-17.523h-.021a9.23 9.23 0 0 0 .021-.625 15.464 15.464 0 0 0-27.133.625h-.09a8.762 8.762 0 0 0 0 17.523c.106.002.21 0 .313-.006z",
    style: {
      fill: "#fff"
    },
    transform: "translate(-15791.72 -21856)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#d)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16504.627 22169.777h7.781a2.534 2.534 0 0 0 0-5.068h-.006c0-.059.006-.119.006-.18a4.471 4.471 0 0 0-7.846.18h-.025a2.534 2.534 0 0 0 0 5.068z",
    "data-name": "Trac\\xE9 364",
    style: {
      fill: "#fff"
    },
    transform: "translate(-15856.46 -21866)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 240"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.371 12.279a17.732 17.732 0 0 1 31.724 0L119.338 96.8a17.741 17.741 0 0 1-15.862 25.675H18.991A17.741 17.741 0 0 1 3.129 96.8z",
    "data-name": "Trac\\xE9 354",
    style: {
      fill: "#aaa"
    },
    transform: "translate(621.767 264.527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.173 32.18 1.38-43.38H2.806l1.38 43.38zM11.68 58.8a10.509 10.509 0 0 0 10.944-10.944c0-6.507-4.535-11.042-10.944-11.042S.736 41.349.736 47.856A10.509 10.509 0 0 0 11.68 58.8z",
    "data-name": "Trac\\xE9 355",
    style: {
      fill: "#fff"
    },
    transform: "translate(671.264 314.197)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#e)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16586.047 22219.494h-67.437a16.61 16.61 0 0 1 0-33.221h.055a25.984 25.984 0 0 1 49.691-8.8 14.066 14.066 0 0 1 18.594 8.813 16.612 16.612 0 0 1-.623 33.213c-.093.001-.186-.005-.28-.005z",
    "data-name": "Trac\\xE9 365",
    style: {
      fill: "#fff"
    },
    transform: "translate(-15944.46 -21869.75)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#f)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16593.416 22224.229h-73.389a18.026 18.026 0 1 1 3.982-35.607 22.717 22.717 0 0 1 18.764-9.883q.87 0 1.727.064a26.185 26.185 0 0 1 50.633 9.373v.082a18.026 18.026 0 0 1-1.717 35.971z",
    "data-name": "Trac\\xE9 366",
    style: {
      fill: "#fff"
    },
    transform: "translate(-15798.72 -21822.23)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongIllustration);
export default __webpack_public_path__ + "static/media/wrong-illustration.388def1153e97282278fce3791d2c4d2.svg";
export { ForwardRef as ReactComponent };